const DEVICE = {
  MOBILE_WIDTH: 900,
};

export default DEVICE;
